"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventEnums_1 = require("../core/eventTypes/EventEnums");
/* eslint-disable no-use-before-define */
exports.default = (function () {
    return {
        createEventContent: createEventContent,
    };
    function createEventContent(_a) {
        var _b = _a === void 0 ? {} : _a, name = _b.name, type = _b.type, libraryContent = _b.libraryContent, contentProfileId = _b.contentProfileId;
        return {
            repository: EventEnums_1.EVENT_REPOSITORY.newscenter,
            name: name,
            type: type,
            libraryContent: libraryContent,
            contentProfileId: contentProfileId,
            // libraryContent: {
            //     ...libraryContent,
            //     teamsiteId: libraryContent.teamsiteId || '00000000-0000-0000-0000-000000000000' // just for test
            // },
            // contentProfileId: contentProfileId || '00000000-0000-0000-0000-000000000000' // just for test
        };
    }
});
//# sourceMappingURL=newscenter.js.map